const Radio = ({
  name,
  value,
  label,
  options,
  disabled = false,
  valid,
  validationText = 'This field is required!',
  onChange,
}) => {
  return (
    <div className="input-group">
      <label>{label}</label>
      {!valid && (
        <span style={{ marginTop: '-6px' }} className="error">
          {validationText}
        </span>
      )}

      <div className="mt2">
        {options.map((option) => (
          <div key={option.id} className="flex items-center">
            <input
              id={option.id}
              name={name}
              value={value}
              disabled={disabled}
              type="radio"
              checked={option.id === value}
              onChange={onChange}
            />
            <span htmlFor={option.id} className="ml2">
              {option.title}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Radio;
